import {
  BarChart3,
  BookOpen,
  ClipboardCheck,
  LayoutDashboard,
  MessageCircle,
  User,
  Users,
} from 'lucide-react'
import { Outlet } from 'react-router-dom'
import { DashboardShell } from './dashboard-shell'

const NAV_ITEMS = [
  { label: 'Dashboard', to: '/instructor/dashboard', icon: LayoutDashboard },
  { label: 'My courses', to: '/instructor/courses', icon: BookOpen },
  { label: 'Students', to: '/instructor/students', icon: Users },
  { label: 'Assignments', to: '/instructor/assignments', icon: ClipboardCheck },
  { label: 'Discussions', to: '/instructor/discussions', icon: MessageCircle },
  { label: 'Analytics', to: '/instructor/analytics', icon: BarChart3 },
  { label: 'Profile', to: '/profile', icon: User },
]

export function InstructorLayout() {
  return (
    <DashboardShell navItems={NAV_ITEMS}>
      <Outlet />
    </DashboardShell>
  )
}
